'use client'

import { createContext, type ReactNode, useContext, useEffect, useMemo, useState } from 'react'
import { useMedia } from 'react-use'

type BreakpointProviderType = {
  isDesktop: boolean
  loading: boolean
}

const BreakpointContext = createContext<BreakpointProviderType | null>(null)

type Props = {
  children: ReactNode
}

export const BreakpointProvider = ({ children }: Props) => {
  const [loading, setLoading] = useState(true)
  const isDesktop = useMedia('(min-width: 60rem) and (pointer: fine)', false)

  // NOTE: This is okay, no dependencies, no other uses of state
  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setLoading(false), [])

  const value = useMemo(() => ({ isDesktop, loading }), [isDesktop, loading])

  return <BreakpointContext.Provider value={value}>{children}</BreakpointContext.Provider>
}

export const useBreakpoints = (): BreakpointProviderType => {
  const breakpoints = useContext(BreakpointContext)

  if (!breakpoints) throw new Error('useBreakpoints must be used within BreakpointProvider')

  return breakpoints
}
